import { Navigate } from "react-router-dom";
import { RoutePaths } from "./routes.contants";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

interface IPropsPrivateRoute {
  isPrivate?: boolean;
}

export default function withRouteProtected(WrappedComponent: any) {
  return ({ isPrivate = false }: IPropsPrivateRoute) => {
    return isPrivate ? (
      <>
        <AuthenticatedTemplate>
          <WrappedComponent />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Navigate to={RoutePaths.Login} replace />
        </UnauthenticatedTemplate>
      </>
    ) : (
      <WrappedComponent />
    );
  };
}
